<!-- 欢迎页 -->
<template>
  <div class="box">
    <div class="title">{{ title }}</div>
    <img src="@/image/login/bg.png" alt="" srcset="">
  </div>
</template>

<script>
export default {
  name: "Welcome",
  components: {
  },
  props: {},
  data() {
    return {
      title: "欢迎使用 致善阔贤管理系统"
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box {
  margin: 50px auto;
  text-align: center;


  .title {
    color: rgba(0, 0, 0, 0.65);
    font-size: 20px;
  }

  img{
    width: 400px;
    margin-top:20px
  }
}
</style>
